module.exports = __webpack_public_path__ + "static/img/12.0afb020.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/eng/12.png
// module id = 0uJ/
// module chunks = 0